import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import './App.css';

// Lazy load components that aren't needed on initial page load
const PhotographyPage = lazy(() => import('./components/PhotographyPage'));
const Projects = lazy(() => import('./components/Projects'));
const MapPage = lazy(() => import('./components/MapPage'));
const StatsPage = lazy(() => import('./components/StatsPage'));
const AuroraPage = lazy(() => import('./components/AuroraPage'));
const MoonPage = lazy(() => import('./components/MoonPage'));
const PlanetPage = lazy(() => import('./components/PlanetPage'));
const AuroraGame = lazy(() => import('./components/game/AuroraGame'));
const ConnectionsGame = lazy(() => import('./components/ConnectionsGame'));
// Password-gated admin tool — deliberately not linked from the nav.
const ExportPage = lazy(() => import('./components/ExportPage'));

// Loading fallback component
const PageLoader = () => (
  <div className="page-loader">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.side-menu') && !event.target.closest('.hamburger-menu')) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  return (
    <>
      <button 
        className="hamburger-menu"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
      >
        <span className={`hamburger-line ${menuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${menuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${menuOpen ? 'active' : ''}`}></span>
      </button>

      <div className={`menu-overlay ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(false)}></div>

      <nav className={`side-menu ${menuOpen ? 'active' : ''}`}>
        <div className="menu-content">
          <h2>Navigation</h2>
          <ul className="menu-items">
            <li>
              <Link 
                to="/" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/' ? 'active' : ''}
              >
                home
              </Link>
            </li>
            <li>
              <Link 
                to="/photography" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/photography' ? 'active' : ''}
              >
                photography
              </Link>
            </li>
            <li>
              <Link 
                to="/projects" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/projects' ? 'active' : ''}
              >
                projects
              </Link>
            </li>
            <li>
              <Link 
                to="/map" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/map' ? 'active' : ''}
              >
                map
              </Link>
            </li>
            <li>
              <Link 
                to="/stats" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/stats' ? 'active' : ''}
              >
                stats
              </Link>
            </li>
            <li>
              <Link 
                to="/aurora" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/aurora' ? 'active' : ''}
              >
                aurora
              </Link>
            </li>
            <li>
              <Link 
                to="/moon" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/moon' ? 'active' : ''}
              >
                moon
              </Link>
            </li>
            <li>
              <Link 
                to="/planets" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/planets' ? 'active' : ''}
              >
                planets
              </Link>
            </li>
            <li>
              <Link 
                to="/game" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/game' ? 'active' : ''}
              >
                game
              </Link>
            </li>
            <li>
              <Link 
                to="/connections" 
                onClick={() => setMenuOpen(false)}
                className={location.pathname === '/connections' ? 'active' : ''}
              >
                connections
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <div className="content">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/photography" element={<PhotographyPage />} />
              <Route path="/photography/:place" element={<PhotographyPage />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/stats" element={<StatsPage />} />
              <Route path="/aurora" element={<AuroraPage />} />
              <Route path="/moon" element={<MoonPage />} />
              <Route path="/planets" element={<PlanetPage />} />
              <Route path="/game" element={<AuroraGame />} />
              <Route path="/connections" element={<ConnectionsGame />} />
              <Route path="/export" element={<ExportPage />} />
            </Routes>
          </Suspense>
        </div>
      </div>
    </Router>
  );
}

export default App;